'use client'
import dynamic from 'next/dynamic';
import {useTranslations} from "next-intl";

const PWAPrompt = dynamic(() => import('react-ios-pwa-prompt'), { ssr: false });

const PwaIosPrompt = () => {
  const t = useTranslations('PwaPrompt')

  return (
    <PWAPrompt
      timesToShow={1}
      promptOnVisit={1}
      copyTitle={t('title')}
      copyDescription={'Add the app to your home screen'}
      appIconPath={'https://i.ibb.co/kGNrm5R/icon-192x192.png'}
    />
  )
}

export default PwaIosPrompt
